export default __webpack_public_path__ + "static/media/GoodMannersOnThePhone_08.6fa92c5e.png";